<button class="back-button" [ngClass]="variant" (click)="goBack()" data-testid="back-button">
  <span class="icon"><img src="/images/menu-arrow.png"/></span>
</button>
